/**
 * The V3 look for the owner portal's detail surfaces (COL-528).
 *
 * The prototype's tabs are an underlined rail, not the pill group shadcn's
 * TabsList defaults to. Three surfaces carry tabs — property detail, the
 * tenant dialog, and anything that grows them later — and three copies of the
 * same override is how two of them end up one pixel apart. So the classes live
 * here once and each surface passes its own `v3` through.
 *
 * NO FLAG IS READ HERE. These are pure string builders that take the answer,
 * so the module stays importable without React or a session — the moment it
 * re-exported the hook it pulled AuthContext (and localStorage) in behind it,
 * and its own unit test stopped loading.
 *
 * Returning the V2 string unchanged when the flag is off matters as much as
 * the V3 one: the same components render for staff and for owners without the
 * shell, and those pages must not move.
 */
/** Petrol, hairline and the muted ink, matching the prototype's tokens. */
export const OWNER_V3 = {
  petrol: "#0F4C4A",
  hairline: "#ECE7DD",
  muted: "#7A8E8C",
  body: "#47605E",
  clay: "#C0714F",
  tint: "#E3EFED",
} as const;

/**
 * The tab rail. `h-auto` and the resets are needed because TabsList ships a
 * fixed height, a background and a radius that an underlined rail must not
 * inherit — overriding them is the whole difference between the two looks.
 */
export function ownerTabsListClass(v3: boolean): string {
  return v3
    ? "h-auto w-full justify-start gap-6 rounded-none border-b border-[#ECE7DD] bg-transparent p-0"
    : "rounded-xl bg-muted/60 p-1";
}

/**
 * One tab. The active state is a 2px petrol rule sitting ON the rail's border,
 * so -mb-px pulls it down over the line rather than leaving a gap above it.
 */
export function ownerTabsTriggerClass(v3: boolean): string {
  return v3
    ? "-mb-px rounded-none border-b-2 border-transparent bg-transparent px-0 pb-2.5 pt-0 text-[13.5px] font-medium text-[#7A8E8C] shadow-none data-[state=active]:border-[#0F4C4A] data-[state=active]:bg-transparent data-[state=active]:font-semibold data-[state=active]:text-[#0F4C4A] data-[state=active]:shadow-none"
    : "rounded-lg";
}
